import { isProduction } from '@magicschool/utils/nextjs/metadata';
import type { RefObject } from 'react';
import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { USE_INTERCOM } from './constants';

interface IntercomStore {
  unreadCount: number;
  onUnreadCountChange: (count: number) => void;
  triggerRef: RefObject<HTMLButtonElement | null> | null;
  updateTriggerRef: (ref: RefObject<HTMLButtonElement | null>) => void;
  isEnabled: boolean;
}

const useIntercomStoreBase = create<IntercomStore>((set) => ({
  isEnabled: isProduction() || USE_INTERCOM,
  unreadCount: 0,
  onUnreadCountChange: (count) => set({ unreadCount: count }),
  triggerRef: null,
  updateTriggerRef: (ref: RefObject<HTMLButtonElement | null>) => set({ triggerRef: ref }),
}));

/**
 * Hook to access Intercom store with shallow memoization baked in.
 * This prevents unnecessary re-renders when store values don't change.
 */
export const useIntercomStore = <T extends object>(selector: (state: IntercomStore) => T): T => {
  return useIntercomStoreBase(useShallow(selector));
};
